import React from 'react';
import { LOGOS } from '../mock';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';

export function TopStats() {
  const { topStats } = useBookersContent();
  return (
    <section className="mx-auto max-w-7xl px-5 lg:px-8 py-16 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
        {topStats.map((s, i) => (
          <div key={i} className={`reveal px-2 ${i > 0 ? 'md:border-l md:border-black/10 md:pl-10' : ''}`} style={{ transitionDelay: `${i * 90}ms` }}>
            <p className="text-sm text-[#8b8b95] font-medium">{s.tag}</p>
            <p className="font-display text-5xl md:text-6xl mt-2 text-[#0b0b0f]">{s.value}<span className="text-3xl align-top">{s.suffix}</span></p>
            <p className="text-[15px] text-[#55555f] mt-2 max-w-[220px]">{s.note}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export function LogoMarquee() {
  const { t } = useI18n();
  const row = [...LOGOS, ...LOGOS];
  return (
    <section className="py-12 border-y border-black/5 bg-[#fafafb]">
      <p className="text-center text-sm text-[#8b8b95] font-medium mb-8">{t('stats.marquee')}</p>
      <div className="marquee-mask overflow-hidden">
        <div className="flex w-max animate-marquee items-center gap-16 px-8">
          {row.map((name, i) => (
            <span key={i} className="font-display text-2xl text-[#c2c2cc] whitespace-nowrap hover:text-[#0b0b0f] transition-colors">{name}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
